import { BUSINESS_UUID, CASE_ID } from '../../utils/constants';

export const bankId = (state) => state.config.get('bank_id');
export const brandId = (state) => state.config.get('brand_id');
export const accessToken = (state) => state.config.get('access_token');
export const business_uuid = (state) => state.config.get(BUSINESS_UUID);
export const apiBaseUrlLiberty = (state) => state.config.get('apiBaseUrlLiberty');
export const apiBaseUrl3 = (state) => state.config.get('apiBaseUrl3');
export const apiBaseUrlPaas = (state) => state.config.get('apiBaseUrlPaas');
export const stubsEnabled = (state) => state.config.get('stubs');
export const getCaseId = (state) => (state && state.config ? state.config.get(CASE_ID) : '');

export const isSoleTrader = (state) => {
  const business_type = state.config ? state.config.get('business_type') : '';
  return business_type && decodeURIComponent(business_type).toLowerCase() === 'sole trader';
};
